import cjson from 'compressed-json';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { SimilarCandidateService } from 'src/app/_services/similar-candidate.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { SimilarCandidateDetails } from 'src/app/common-interfaces-classes/SimilarCandidate';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { DataService } from 'src/app/data.service';
import { JdDataService } from 'src/app/jd-data.service';
import { SimilarCandidateFilterComponent } from 'src/app/similar-candidate-filter/similar-candidate-filter.component';

import * as _ from "underscore";
import { Location } from '@angular/common';
import { OpenaiService } from 'src/app/openai/openai.service';

@Component({
    selector: 'app-report-details',
    templateUrl: './report-details.component.html',
    styleUrls: ['./report-details.component.scss'],
    standalone: false
})
export class ReportDetailsComponent implements OnInit, OnDestroy {
  talentfilterdata: any
  totalcount: any

  queryParams = {}

  subscriptions: Array<Subscription> = [];

  isComingFromJD: boolean = false;

  continentComingFromHistory: string ;
  redirectType: string;
  isComingFromNLSearch: boolean = false;
  locationContinentname:any[] = [];
  filterData: any;
  filterType: string[] = [];
  refreshApiCall: boolean = false;
  jdResponse:any= null

  constructor(private route: ActivatedRoute, private personsearchservice: PersonSearchService, private router: Router,
    private localstorageservice: LocalStorageService, private filterDataHandlerService: FilterDataHandlerService,
    private aggService: AggregationService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private dataService: DataService,
    private modalService: NgbModal, private jdDataService: JdDataService, private talentInsightsService: TalentInsightsService,
    private similarCandidateService: SimilarCandidateService, private location: Location, private openaiService: OpenaiService
  ) {
    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.getprofessionalcount()
    });
    this.queryParams = this.route.snapshot.queryParams;
    this.redirectType = this.queryParams['redirect'];

    if (this.jdDataService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdDataService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    if(this.route.snapshot.queryParams.type == 'job-description') {
      this.refreshApiCall = true;
    }
  }

  ngOnInit(): void {
    this.fetchInsightsTabData();
    this.getJobtitleSkillSuggestions('refresh');
    const filterMethodExecEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_data => {
      this.filterData = _data;
      if(this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'pastjobtitle') {
        this.getJobtitleSkillSuggestions();
      }
      if(this.filterData?.filterType == 'allfilters') {
          this.localstorageservice.setItem('jobCurrency', 'USD');
          this.localstorageservice.setItem('currencyCountry', null);
      }
      this.getprofessionalcount()
    });
    this.subscriptions.push(filterMethodExecEvent);

    const jdFilterMethodEvent = this.jdDataService.jdDataInTIReportDetails.subscribe(response => {
      this.jdResponse = response;
      if(this.jdResponse != null ) {
      this.getJobtitleSkillSuggestions();
    this.jdDataService.clearJDDataInTIReportDetails();
      } else {

      }

    })
    this.subscriptions.push(jdFilterMethodEvent);


  }

  /**
   * Determines if a given tab is active based on the current router URL.
   *
   * @param tab - The string identifier of the tab to check.
   */
  isTabActive(tab: string): boolean {
    return this.router.url.includes(tab);
  }


  fetchInsightsTabData() {
    let historyReqObj = this.dataService.getData();
    if (historyReqObj?.allLists && this.route.snapshot.queryParamMap.get('searchSource') === 'history-component') {
      if(historyReqObj?.allLists?.job_search_keys?.jobtitles || historyReqObj?.allLists?.job_search_keys?.skills) {
        const jobtitle = historyReqObj?.allLists?.job_search_keys?.jobtitles.toString().split('; ').map(item => item.trim());
        const skills =  historyReqObj?.allLists?.job_search_keys?.skills.toString().split('; ').map(item => item.trim());
      const filterSuggestions = {
        jobtitles: jobtitle,
        skills: skills
      }
        this.localstorageservice.setItem('aiSuggestions', filterSuggestions);
      }
      historyReqObj.allLists['booleanquery'] = historyReqObj.requestObject['booleanquery'];
          if(historyReqObj?.allLists.continentstobeincluded.length > 0) {
      if(historyReqObj?.allLists.continentstobeincluded == '') {
        historyReqObj.allLists.continentstobeincluded = [];
      }
    }
    if(historyReqObj?.allLists?.locationcontinents?.length > 0){
      this.locationContinentname = historyReqObj?.allLists?.locationcontinents;
      const aggReq = this.aggService.getRequestWithFilters();
      aggReq.locationcontinents = this.locationContinentname;
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      const filterData = this.filterDataHandlerService.fetchFilterData;
      filterData.locationcontinents = this.locationContinentname;
    }

   //   this.continentComingFromHistory = historyReqObj?.allLists.continentstobeincluded[0];
      this.filterDataHandlerService.setFilterData(historyReqObj?.allLists);
      this.localstorageservice.setItem('talentfilters', JSON.stringify(historyReqObj.allLists));
      this.localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(historyReqObj.allLists));
      if (historyReqObj?.allLists?.locationSelectedList.length > 0) {
        const locations = historyReqObj.allLists.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const location = locations.join(',');
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);

          }
        })

      } else if (this.route.snapshot.queryParamMap.get('type') === 'job-description') {
        const aggReq = this.aggService.getRequestWithFilters();
            if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
              this.localstorageservice.setItem('currencyCountry', res.data.country_name);

            }
          })

        }
      } else{
  this.localstorageservice.setItem('jobCurrency', 'USD');
          this.localstorageservice.setItem('currencyCountry', null);
      }
              this.getJobtitleSkillSuggestions('refresh');

      this.setTalentInsightsHistory();
    }

    this.talentfilterdata = JSON.parse(this.localstorageservice.getItem('talentfilters') || "{}");
    const filterData = JSON.parse(this.localstorageservice.getItem(GeneralConstants.LS_KEYS.TALENT_FILTERS));
    // let filterData = this.filterDataHandlerService.fetchFilterData;

    // console.log(filterData,'report details filter data');

    if (!filterData || _.isEmpty(filterData)) {

      this.filterDataHandlerService.reset();
    } else {
      // debugger
      this.filterDataHandlerService.setFilterData(filterData);
    }
    this.personsearchservice.setTalentinsightsFilterAI(this.talentfilterdata)

    this.talentfilterdata['company'] = this.talentfilterdata.company ? this.talentfilterdata.company : [];
    this.talentfilterdata['industry'] = this.talentfilterdata.industry ? this.talentfilterdata.industry : [];
    this.talentfilterdata['function'] = this.talentfilterdata.function ? this.talentfilterdata.function : [];
    this.talentfilterdata['school'] = this.talentfilterdata.school ? this.talentfilterdata.school : [];
    this.talentfilterdata['degree'] = this.talentfilterdata.degree ? this.talentfilterdata.degree : [];
    this.talentfilterdata['keyword'] = this.talentfilterdata.keyword ? this.talentfilterdata.keyword : [];
    this.talentfilterdata['fromyearsofexperience'] = this.talentfilterdata.fromyearsofexperience ? this.talentfilterdata.fromyearsofexperience : null;
    this.talentfilterdata['toyearsofexperience'] = this.talentfilterdata.toyearsofexperience ? this.talentfilterdata.toyearsofexperience : null;
    this.getprofessionalcount();
    //   const tab = this.router.url.split('/')[2];

    //this.redirecttotab(tab)
    this.personsearchservice.setTalentinsights(this.talentfilterdata);
    // const tab = this.router.url.split('/')[2];
    // this.router.navigate([`/report-details/${tab}`], {state: this.talentfilterdata, skipLocationChange: false})
    // const recCandidateDataEvent = this.aggService.recCandidateDataEvent.subscribe(response => this.totalcount = response.totalresultscount);
    // this.subscriptions.push(recCandidateDataEvent);
  }

  /**
  * set history in talent insights
  * @param {string} updateCall Used to know status, either function is called for history update or new history creation
  */
  setTalentInsightsHistory(updateCall = false, type?: string) {
    const aggReq = this.aggService.getRequestWithFilters();
    delete aggReq['aggregatetype'];
    delete aggReq['aggregatescount'];
    delete aggReq['resultsize'];
    delete aggReq['startindex'];
    if (!updateCall)
      delete aggReq['talentdiscoveryhistoryid'];
    if(type == 'suggestions') {
       aggReq.talentdiscoveryhistoryid = this.route.snapshot.queryParams.talentdiscoveryhistoryid ? this.route.snapshot.queryParams.talentdiscoveryhistoryid : this.localstorageservice.getItem('talentInsightsHistoryId');;

      // aggReq.talentdiscoveryhistoryid = this.localstorageservice.getItem('talentInsightsHistoryId');
    }
    aggReq['module'] = GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    const aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    if(aiSuggestions) {
    const job_search_keys = {
      jobtitles: aiSuggestions?.jobtitles,
      skills: aiSuggestions?.skills
    }
    aggReq['job_search_keys'] = job_search_keys;
    }

    if(this.isComingFromJD) {
      delete aggReq.nlsearchquery;
        aggReq.locationcontinents = this.locationContinentname;
    }
    aggReq.continentstobeincluded = aggReq?.continentstobeincluded?.length ? _.uniq(_.flatten(aggReq?.continentstobeincluded)): [this.localstorageservice.getItem('defaultContinent')]

    this.personsearchservice.setInsightsHistory(aggReq).subscribe((res) => {
      if (res) {
        this.localstorageservice.setItem('talentInsightsHistoryId', res.talentdiscoveryhistoryid);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.filterDataHandlerService.reset();
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  }

  /**
   *
   * TODO : This method can be replaced with another private utility method which will be called whenever a filter operation is emitted.
   *
   */
  getfiltesdata(data) {
    this.talentfilterdata['jobtitle'] = data.jobtitle;
    this.talentfilterdata['company'] = data.company;
    this.talentfilterdata['industry'] = data.industry;
    this.talentfilterdata['function'] = data.function;
    this.talentfilterdata['school'] = data.school;
    this.talentfilterdata['degree'] = data.degree;
    this.talentfilterdata['keyword'] = data.keyword;
    this.talentfilterdata['fromyearsofexperience'] = data.fromyearsofexperience;
    this.talentfilterdata['toyearsofexperience'] = data.toyearsofexperience;
    this.talentfilterdata['location'] = data.location;
    this.talentfilterdata['skills'] = data.skills;
    this.talentfilterdata['filterselected'] = 'yes';
    // TODO : Capture event emission here as well.
    this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.getprofessionalcount();


    this.personsearchservice.setTalentinsights(this.talentfilterdata);
    //    const NavigationExtras :NavigationExtras ={
    //     state: this.talentfilterdata,
    //   }
    //  // window.location.reload();
    const tab = this.router.url.split('/')[2];
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([`/report-details/${tab}`], { state: this.talentfilterdata, skipLocationChange: true })
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    // this.router.navigate([location.pathname]));
  }

  redirecttotab(type) {
    this.router.navigate([`/report-details/${type}`], { replaceUrl: true })
  }

  getprofessionalcount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = this.talentfilterdata && this.talentfilterdata['skills']?.length > 0 ? 'skills' : 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe(res => {
      if (res && res.data) {
        this.totalcount = res.data.totalresultscount;
      }
    })
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  /**
   * Edit Jd parameters from talent insights
   */
  editSimilarCandidateFilters() {
    const jdData = this.jdDataService.jdDataFromSession;

    // if (this.continentComingFromHistory) {
    //   jdData.locationcontinent = [this.continentComingFromHistory];
    // }

    this.personsearchservice.passsimilarcandidatesdata({
      data: { ...jdData },
      calledfrom: this.redirectType == 'nl-search' ? GeneralConstants.REDIRECT_SOURCES.NL_SEARCH : GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION
    });
    const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
    const modalInstance: SimilarCandidateFilterComponent = modalRef.componentInstance;
    modalInstance.type = "edit";

    modalRef.result.then((res) => {
      if (res && res.action === 'submit') {
        this.filterType = res.filterType;
        this.similarCandidateService.emitSimilarCandidateEvent();
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        const similarObject = res?.data ? res.data : new SimilarCandidateDetails();
        this.jdDataService.setSessionData(uniqueHash, similarObject);
        if (res.data.locationcontinent) {
          const filterData = this.filterDataHandlerService.fetchFilterData;

          /**Update local storage and filter data in service if continent changes from jd-search modal  */
          {
            //If searchd via histroy and continent is updated from jd modal then `continentComingFromHistory` also get updated
          //  this.continentComingFromHistory = res.data.locationcontinent;
            filterData.continentstobeincluded = res.data.locationcontinent?.length > 0 ? res.data.locationcontinent: [this.localstorageservice.getItem('defaultContinent')];
            this.filterDataHandlerService.setFilterData(filterData);
            this.localstorageservice.setItem('talentfilters', JSON.stringify(filterData));
            this.localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(filterData));
            if (res?.data?.currentlocation?.length > 0) {
              const locations = res?.data?.currentlocation.map(loc => loc.key.replace('.searchastext', ''));
              const payload = { locations: locations }
              this.talentInsightsService.getLocationCurrency(payload).subscribe((response: any) => {
                if (response.status === 'success' && response.data) {
                  this.localstorageservice.setItem('jobCurrency', response.data.base_currency);
                  this.localstorageservice.setItem('currencyCountry', res.data.country_name);

                }
              })

            } else {
              this.localstorageservice.setItem('jobCurrency', 'USD');
              this.localstorageservice.setItem('currencyCountry',null);

            }
           // this.filterDataHandlerService.setUpdatedContinent(true)
          }
        } else {
  if (res?.data?.currentlocation?.length > 0) {
              const locations = res?.data?.currentlocation.map(loc => loc.key.replace('.searchastext', ''));
              const payload = { locations: locations }
              this.talentInsightsService.getLocationCurrency(payload).subscribe((response: any) => {
                if (response.status === 'success' && response.data) {
                  this.localstorageservice.setItem('jobCurrency', response.data.base_currency);
                  this.localstorageservice.setItem('currencyCountry', res.data.country_name);

                }
              })

            } else {
              this.localstorageservice.setItem('jobCurrency', 'USD');
            }
          }
          if(similarObject?.locationContinentName?.length > 0) {
            const aggReq = this.aggService.getRequestWithFilters();
            this.locationContinentname = similarObject?.locationContinentName;
            aggReq.locationcontinents = similarObject?.locationContinentName;
            this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
            const filterData = this.filterDataHandlerService.fetchFilterData;
            filterData.locationcontinents = this.locationContinentname;
            this.filterDataHandlerService.setFilterData(filterData);

          } else {
             const aggReq = this.aggService.getRequestWithFilters();
            this.locationContinentname = [];
            aggReq.locationcontinents = [];
            this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
            const filterData = this.filterDataHandlerService.fetchFilterData;
            filterData.locationcontinents = [];
            this.filterDataHandlerService.setFilterData(filterData);
          }
        this.extractInsightsTabs();
      }
    });
  }

  /** Extract current tab of insights and send event to update the component */
  extractInsightsTabs() {
    this.getprofessionalcount();
    const currentTab = this.talentInsightsService.currentTabTalentInsights;
    const aggreq = this.aggService.getRequestWithFilters();
    if (this.filterType?.length > 0 && (this.filterType.includes('skills') || this.filterType.includes('jobtitle'))) {
      this.getJobtitleSkillSuggestions();
    } else {
    this.jdDataService.emitInsightsEvent({ action: 'refresh', tab: currentTab, filterType: this.filterType });

    }

    this.setTalentInsightsHistory(true);
  }

  getJobtitleSkillSuggestions(type?: string) {

      const aggReq = this.aggService.getRequestWithFilters();
     if((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0
       || (aggReq?.job_description_keys?.job_titles?.length > 0) || aggReq?.job_description_keys?.skills?.length > 0) {
        let payload = {};
              if(this.isComingFromJD) {
   payload = {
            skills: (aggReq.job_description_keys?.skills ? aggReq.job_description_keys.skills : []),
            jobtitles: (aggReq.job_description_keys?.job_titles ? aggReq.job_description_keys.job_titles : []),
            boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
          }
              } else {
                   payload = {
            skills: aggReq.preferredskills.concat(aggReq.job_description_keys?.skills ? aggReq.job_description_keys.skills : []),
            jobtitles: aggReq?.jobtitles.concat(aggReq.pastjobtitles ? aggReq.pastjobtitles : []).concat(aggReq.job_description_keys?.job_titles ? aggReq.job_description_keys.job_titles : []),
            boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
          }
              }


              if(type == 'refresh') {
                const suggestions = this.localstorageservice.getItem('aiSuggestions');
                if(suggestions) return;
             }
          this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(( res:any)=>{
      const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
        jobtitles: titles,
        skills: skills
      }
      this.localstorageservice.setItem('aiSuggestions', filterSuggestions);
      this.talentInsightsService.setAISuggestionData(filterSuggestions);
      this.talentInsightsService.sendAISuggestionData(filterSuggestions);
      this.setTalentInsightsHistory(true, 'suggestions');

     })
        }
      }


}




